import React from 'react';
import classNames from 'classnames';
import { SectionSplitProps } from '../../utils/SectionProps';
import Image from '../elements/Image';

const propTypes = {
  ...SectionSplitProps.types
}

const defaultProps = {
  ...SectionSplitProps.defaults
}

const Descriptions = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  invertMobile,
  invertDesktop,
  alignTop,
  imageFill,
  ...props
}) => {

  const outerClasses = classNames(
    'features-split section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-split-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const splitClasses = classNames(
    'split-wrap',
    invertMobile && 'invert-mobile',
    invertDesktop && 'invert-desktop',
    alignTop && 'align-top'
  );


  return (
<React.Fragment>

    <section
      {...props}
      className={outerClasses}
    >
      <div className="container">      
          <div className={innerClasses}>        
          <div className={splitClasses}>

            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  <a style={{color:"#5658DD"}} rel="noreferrer" 
                  href="mailto:ian@droneshiftmedia.com" target="_blank">
                    Email ian@droneshiftmedia.com for more info</a>
                  </div>
                <h3 className="mt-0 mb-12">
                  Real Estate
                  </h3>
                <p className="m-0">
                According to MLS research, a real estate listing with aerial photos and footage sells 68% faster than one without. Ready to put your listing on the map?  </p>
              </div>
              <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">
                <Image
                  src={require('./../../assets/images/RealEstate.png')}
                  alt="Features split 01"
                  width={528}
                  height={396} />
              </div>
            </div>

            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-right" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  <a style={{color:"#5658DD"}} rel="noreferrer" 
                  href="mailto:ian@droneshiftmedia.com" target="_blank">
                    Email ian@droneshiftmedia.com for more info</a>
                  </div>
                <h3 className="mt-0 mb-12">
                  Business Showcase
                  </h3>
                <p className="m-0">
                Looking for a way to set your business apart from the competition? Consider integrating our unique perspectives into your social media flow.
                  </p>
              </div>
              <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">
                <Image
                  src={require('./../../assets/images/ProductShowcase.png')}
                  alt="Features split 02"
                  width={528}
                  height={396} />
              </div>
            </div>

            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  <a style={{color:"#5658DD"}}  rel="noreferrer" 
                  href="mailto:ian@droneshiftmedia.com" target="_blank">
                    Email ian@droneshiftmedia.com for more info</a>
                  </div>
                <h3 className="mt-0 mb-12">
                  Custom Creations
                  </h3>
                <p className="m-0">
                Have an event you want to see from above? Maybe you have an idea that has never been done before. Send us your idea and let’s make it a reality!
                  </p>
              </div>
              <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">
                <Image
                  src={require('./../../assets/images/CustomCreations.jpg')}
                  alt="Features split 03"
                  width={528}
                  height={396} />
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
    </React.Fragment>
  );
}

Descriptions.propTypes = propTypes;
Descriptions.defaultProps = defaultProps;

export default Descriptions;